import { useAuth } from '../auth/useAuth.js';
import { useTenantContext } from '../api/tenant-context.js';

function initialsOf(s: string): string {
  return s
    .split(/\s+/)
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export function UserCard(): JSX.Element {
  const { claims } = useAuth();
  const { tenant } = useTenantContext();
  const display = claims?.name ?? claims?.email ?? 'Usuario';
  const initials = initialsOf(display);
  const tenantLabel = tenant?.name ?? '—';
  return (
    <div className="flex items-center gap-2.5 p-2">
      <div className="w-7 h-7 rounded-full flex items-center justify-center text-[11px] font-semibold text-white shrink-0"
           style={{ background: 'linear-gradient(135deg, #ff6b73, #c41e29)' }}>
        {initials || 'ZE'}
      </div>
      <div className="flex-1 min-w-0 leading-tight">
        <div className="text-[12.5px] font-medium truncate">{display}</div>
        <div className="text-[11px] text-ink-4 truncate">Admin · {tenantLabel}</div>
      </div>
    </div>
  );
}
